export function dateFormat(stemp: number | undefined) {
  if (stemp) {
    let fullDate = new Date(stemp)
    let date = fullDate.toUTCString().slice(5, 16)
    let time = fullDate.toLocaleTimeString('en-US',
      { hour12: true, hour: 'numeric', minute: 'numeric' }
    )
    return `${date}, ${time}`
  }
}